import {quickSave as quickSaveAction} from "prosemirror/connectors/actions";

export const quickSave = (state, dispatch) => dispatch(quickSaveAction());